// extracted by mini-css-extract-plugin
module.exports = {"copyIcon":"TdbjOHgpheRA1TSSyIrWi","detailsContainer":"_1YPfxhLDvB7YpyS6D8VIIk","metadataFieldValue":"_27LiPH7hiYAKCHxkGDyqSF","disabled":"_2mFVlkyspPoh_-u7f59DRY"};